import React, { useContext, useState } from 'react';
import { CartContext } from '../Context/CartContext';
import { FaLuggageCart } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import NumberFormat from 'react-number-format';
import OrderSummary from './Booking/OrderSummary';

function Cart(props) {
  const [cart, setCart] = useContext(CartContext);
  const [showCart, setShowCart] = useState(false);

  function toggleCart() {
    setShowCart(!showCart);
  }

  return (
    <React.Fragment>
      <div className={props.wrapperClass} onClick={toggleCart} title="shoppingcart">
        <IconContext.Provider value={{ size: "1.75em", className: "text-white hover:text-blue-800" }}>
          <FaLuggageCart />
        </IconContext.Provider>
        {cart.packageId ?
          <div className="flex px-1 self-start rounded-full text-xs bg-blue-800 text-white">
            {cart.cabins.length}
          </div>
          : null
        }
      </div>
      {showCart ?
        <div className="absolute z-50 bg-teal-700 p-4 rounded-lg " style={{ top: 100, right: 100 }}>
          {cart.packageId ?
            <OrderSummary headerClass="text-white" />
            : <p>The cart is empty</p>
          }
        </div>
        : null
      }
    </React.Fragment>
  );
}

export default Cart;